const PLACEMENT_MEDALS = {
  1: "🥇",
  2: "🥈",
  3: "🥉",
};

const PLACEMENT_LABELS = {
  1: "Золото",
  2: "Серебро",
  3: "Бронза",
};

export const PARTICIPATED_ICON = "🏅";
export const PARTICIPATED_LABEL = "Участвовал";

export function formatParticipatedResult() {
  return `${PARTICIPATED_ICON} ${PARTICIPATED_LABEL}`;
}

export function isPodiumPlacement(placement) {
  const p = Number(placement);
  return Number.isFinite(p) && p >= 1 && p <= 3;
}

export function getPlacementMedal(placement) {
  const p = Number(placement);
  if (!isPodiumPlacement(p)) return null;
  return PLACEMENT_MEDALS[p];
}

export function getPlacementLabel(placement) {
  const p = Number(placement);
  if (!isPodiumPlacement(p)) return null;
  return PLACEMENT_LABELS[p];
}

export function formatCompetitionPlacement(placement) {
  const p = Number(placement);
  if (!isPodiumPlacement(p)) return null;
  const medal = getPlacementMedal(p);
  const label = getPlacementLabel(p);
  return `${medal} ${label}`;
}

export function buildCompetitionMedalDescription(medal) {
  if (!medal) return "";
  const title = medal.competition?.title || "Соревнование";
  const place = getPlacementLabel(medal.placement);
  return `${place} — «${title}»`;
}

export function competitionResultLabel(row) {
  if (!row) return null;
  if (row.result_status === "no_show") return "Не пришёл";
  if (row.result_status === "participated") return formatParticipatedResult();
  if (row.result_status === "placed" && row.placement) {
    if (isPodiumPlacement(row.placement)) {
      return formatCompetitionPlacement(row.placement);
    }
    return formatParticipatedResult();
  }
  return null;
}

export function isCompetitionResultMarked(row) {
  return (
    row?.result_status === "placed" ||
    row?.result_status === "participated" ||
    row?.result_status === "no_show"
  );
}

export const QUICK_PLACEMENTS = [1, 2, 3];
